// extracted by mini-css-extract-plugin
export default {"error":"social-suggested-followees-RecommendedExternalConnectionsDataProvider__error--1Gs0O"};